import { render, staticRenderFns } from "./OrganizersDashlet.vue?vue&type=template&id=6842e17f"
import script from "./OrganizersDashlet.vue?vue&type=script&lang=js"
export * from "./OrganizersDashlet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports